import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/dashboard/Index.vue"),
    children: [
      {
        path: "/",
        component: () => import("../views/dashboard/ProjectList.vue")
      },
      {
        path: "project/:projectId/market/:marketId",
        component: () => import("../views/dashboard/Market.vue"),
        redirect: "project/:projectId/market/:marketId/view",
        children: [
          {
            path: "view",
            component: () => import("../views/dashboard/MarketId.vue")
          },
          {
            path: "customer",
            component: () => import("../views/dashboard/Customer.vue"),
            redirect: "customer/market",
            children: [
              {
                path: "market",
                component: () => import("../views/dashboard/MarketCustomer.vue")
              },
              {
                path: "project",
                component: () =>
                  import("../views/dashboard/ProjectCustomer.vue")
              },
              {
                path: "companion",
                component: () =>
                  import("../views/dashboard/CompanionCustomer.vue")
              }
            ]
          },
          {
            path: "customer/:customerId",
            redirect: "customer/:customerId/view"
          },
          {
            path: "customer/:customerId/view",
            component: () => import("../views/dashboard/CustomerId.vue")
          },
          {
            path: "area/:areaId",
            component: () => import("../views/dashboard/MarketId.vue")
          },
          {
            path: "rental",
            component: () => import("../views/dashboard/MarketRental.vue"),
            redirect: "rental/invoices",
            children: [
              {
                path: "invoices",
                component: () => import("../views/dashboard/MarketInvoices.vue")
              },
              {
                path: "meter/water",
                component: () =>
                  import("../views/dashboard/MarketMeterWater.vue")
              },
              {
                path: "meter/elec",
                component: () =>
                  import("../views/dashboard/MarketMeterElec.vue")
              }
            ]
          },
          {
            path: "accounting",
            component: () => import("../views/dashboard/MarketAccounting.vue"),
            redirect: "accounting/invoice",
            children: [
              {
                path: "invoice",
                component: () =>
                  import("../views/dashboard/MarketAccountingInvoiceList.vue")
              },
              {
                path: "receipt",
                component: () =>
                  import("../views/dashboard/MarketAccountingReceiptList.vue")
              },
              {
                path: "billpaymentreport",
                component: () =>
                  import(
                    "../views/dashboard/MarketAccountingBillPaymentList.vue"
                  )
              },
              {
                path: "qrpaymentreport",
                component: () =>
                  import("../views/dashboard/MarketAccountingQRPaymentList.vue")
              },
              {
                path: "creditnote",
                component: () =>
                  import("../views/dashboard/MarketAccountingCreditNoteList.vue")
              }
            ]
          },
          {
            path: "report",
            component: () => import("../views/dashboard/MarketReport.vue"),
            redirect: "report/checkout",
            children: [
              {
                path: "checkout",
                component: () => import("../components/ReportCheckout.vue")
              },
              {
                path: "checkin",
                component: () => import("../components/ReportCheckin.vue")
              },
              {
                path: "active",
                component: () => import("../components/ReportActive.vue")
              },
              {
                path: "cashback",
                component: () => import("../components/ReportCashback.vue")
              },
              {
                path: "invoice",
                component: () =>
                  import("../components/MarketReportInvoice.component.vue")
              },
              {
                path: "booking-daily",
                component: () => import("../views/dashboard/MarketReportBookingDaily.vue")
              },
              {
                path: "booking-monthly",
                component: () => import("../views/dashboard/MarketReportBookingMonthly.vue")
              },
              {
                path: "appeal",
                component: () => import("../components/ReportAppeal.vue")
              },
              {
                path: "contract-suspend",
                component: () => import("../components/ReportContractSuspend.vue")
              },
              {
                path: "auditlog",
                component: () => import("../components/ReportAudit.vue")
              },
              {
                path: "contract-will-expired",
                component: () => import("../components/ReportContractWillExpired.vue")
              },
              {
                path: "meter-digital-elec",
                component: () => import("../components/ReportMeterDigitalElec.vue")
              },
            ]
          },
          {
            path: "approve",
            component: () => import("../views/dashboard/MarketApprove.vue"),
            redirect: "approve/area-interest",
            children: [
              {
                path: "area-interest",
                component: () =>
                  import("../views/dashboard/MarketApproveAreaInterest.vue")
              },
              {
                path: "appeal",
                component: () =>
                  import("../views/dashboard/MarketApproveAppeal.vue")
              },
              {
                path: "setting-billing",
                component: () =>
                  import("../views/dashboard/MarketApproveSettingBilling.vue")
              },
              {
                path: "setting-areaacc",
                component: () =>
                  import("../views/dashboard/MarketApproveSettingAreaAcc.vue")
              },
              {
                path: "setting-task-history",
                component: () =>
                  import("../views/dashboard/MarketApproveSettingHistory.vue")
              },
              {
                path: "contract-check-out",
                component: () =>
                  import("../views/dashboard/MarketApproveContractCheckOut.vue")
              },
              {
                path: "renew-contract",
                component: () =>
                  import("../views/dashboard/MarketApproveRenewContract.vue")
              },
            ]
          },
          {
            path: "setting",
            component: () => import("../views/dashboard/MarketSetting.vue"),
            redirect: "setting/area",
            children: [
              {
                path: "area",
                component: () => import("../views/dashboard/MarketSettingArea.vue")
              },
              {
                path: "bill",
                component: () => import("../views/dashboard/MarketSettingBill.vue")
              },
              {
                path: "penalty",
                component: () => import("../views/dashboard/MarketSettingPenalty.vue")
              },
              {
                path: "water",
                component: () => import("../views/dashboard/MarketSettingMeter.vue")
              },
              {
                path: "elec",
                component: () => import("../views/dashboard/MarketSettingMeter.vue")
              },
              {
                path: "billing",
                component: () => import("../views/dashboard/MarketSettingInvoice.vue")
              },
              {
                path: "areaaccountingproduct",
                component: () => import("../views/dashboard/MarketSettingAccountingproduct.vue")
              },
              {
                path: "settingtask-billing",
                component: () => import("../views/dashboard/MarketSettingTaskBilling.vue")
              },
              {
                path: "settingtask-areaacc",
                component: () => import("../views/dashboard/MarketSettingTaskAreaAcc.vue")
              }
            ]
          },
          {
            path: "overall",
            component: () => import("../views/dashboard/MarketOverall.vue"),
            redirect: "overall/overview",
            children: [
              {
                path: "overview",
                component: () => import("../views/dashboard/MarketOverallOverview.vue")
              },
              {
                path: "income",
                component: () => import("../views/dashboard/MarketOverallIncome.vue")
              },
              {
                path: "income_monthly",
                component: () => import("../views/dashboard/MarketOverallIncomeMonthly.vue")
              },
              {
                path: "income_daily",
                component: () => import("../views/dashboard/MarketOverallIncomeMonthly.vue")
              },
              {
                path: "product",
                component: () => import("../views/dashboard/MarketOverallProduct.vue")
              },

            ]
          },
          {
            path: "interest",
            component: () => import("../views/dashboard/MarketInterest.vue")
          },
          {
            path: "appeal",
            component: () => import("../views/dashboard/MarketAppeal.vue"),
          },
          {
            path: "income-expense",
            component: () => import("../views/dashboard/MarketIncomeExpense.vue"),
          },
        ]
      },
      {
        path: "project/:projectId",
        component: () => import("../views/dashboard/Project.vue"),
        redirect: "project/:projectId/settings",
        children: [
          {
            path: "settings",
            component: () => import("../views/dashboard/ProjectSettings.vue"),
            redirect: "settings/info",
            children: [
              {
                path: "info",
                component: () => import("../views/dashboard/ProjectSettingInfo.vue")
              },
              {
                path: "accountingprodcut",
                component: () =>
                  import("../views/dashboard/ProjectSettingAccountingProduct.vue")
              },
              {
                path: "bankaccount",
                component: () =>
                  import("../views/dashboard/ProjectSettingBankAccount.vue")
              },
              {
                path: "product",
                component: () => import("../views/dashboard/Product.vue")
              },
              {
                path: "asset",
                component: () =>
                  import("../views/dashboard/ProjectSettingAsset.vue")
              },
              {
                path: "personnel",
                component: () =>
                  import("../views/dashboard/ProjectSettingPersonnel.vue")
              },
              {
                path: "documenttemplate",
                component: () =>
                  import("../views/dashboard/ProjectSettingDocumentTemplate.vue")
              },
              {
                path: "settingplan",
                component: () =>
                  import("../views/dashboard/ProjectSettingPlan.vue")
              }
            ]
          },
          {
            path: "reports",
            component: () => import("../views/dashboard/ProjectRecports.vue"),
            // redirect: "project/:projectId/reports/accounting",
            redirect: "reports/accounting",
            children: [
              {
                path: "accounting",
                component: () =>
                  import("../views/dashboard/ProjectReportAccounting.vue"),
                redirect: "accounting/invoice",
                children: [
                  {
                    path: "invoice",
                    component: () =>
                      import(
                        "../views/dashboard/ProjectReportAccountingInvoiceList.vue"
                      )
                  },
                  {
                    path: "receipt",
                    component: () => import("../views/dashboard/ProjectReportAccountingReceiptList.vue"),
                  },
                  {
                    path: "billpaymentreport",
                    component: () => import("../views/dashboard/ProjectReportAccountingBillPaymentList.vue"),
                  },
                  {
                    path: "qrpaymentreport",
                    component: () => import("../views/dashboard/ProjectReportAccountingQRPaymentList.vue"),
                  },
                  {
                    path: "creditnote",
                    component: () => import("../views/dashboard/ProjectReportAccountingCreditNoteList.vue"),
                  }
                ]
              },
              {
                path: "market",
                component: () =>
                  import("../views/dashboard/ProjectReportMarket.vue"),
                redirect: "market/invoice",
                children: [
                  {
                    path: "invoice",
                    component: () => import("../views/dashboard/ProjectReportMarketInvoice.vue"),
                  },
                  {
                    path: "occupancyrate",
                    component: () => import("../views/dashboard/ProjectReportMarketOccupancyRate.vue"),
                  }
                ]
              },
              {
                path: "overall",
                component: () =>
                  import(
                    "../views/dashboard/ProjectOccRateReport.vue"
                  ),
                redirect: "overall/overview",
                children: [
                  {
                    path: "overview",
                    component: () =>
                      import(
                        "../views/dashboard/ProjectOccRateReportOverview.vue"
                      )
                  },
                  {
                    path: "compare",
                    component: () =>
                      import(
                        "../views/dashboard/ProjectOccRateReportCompare.vue"
                      )
                  },
                ]
              },
              {
                path: "digitalmeter",
                component: () =>
                  import("../views/dashboard/ProjectReportDigitalMeter.vue"),
                redirect: "digitalmeter/overall/project",
                children: [
                  {
                    path: "overall/:type",
                    component: () => import("../views/dashboard/ProjectReportDigitalMerterOverall.vue"),
                  },
                  {
                    path: "log",
                    component: () => import("../views/dashboard/ProjectReportDigitalMerterLog.vue"),
                  },
                ]
              },
              {
                path: "digitalmeter/overall",
                redirect: "digitalmeter/overall/project",
              }
            ]
          },
          {
            path: "board",
            component: () => import("../views/dashboard/ProjectBoards.vue"),
          },
          {
            path: "board/:postId",
            component: () => import("../views/dashboard/ProjectBoard.vue"),
          },
          {
            path: "plan",
            component: () => import("../views/dashboard/ProjectPlan.vue"),
          },
        ] 
      },
    ]
  },
  {
    path: "/auth",
    component: () => import("../views/auth/Index.vue"),
    redirect: "/auth/login",
    children: [
      {
        path: "login",
        name: "Login",
        component: () => import("../views/auth/Login.vue")
      },
      // {
      //   path: "sso",
      //   name: "SSO",
      //   component: () => import("../views/auth/SSO.vue")
      // },
      {
        path: "signup",
        component: () => import("../views/auth/SignUp.vue")
      },
      {
        path: "password-recovery",
        component: () => import("../views/auth/PasswordRecovery.vue")
      },
      {
        path: "forgot-password/:userId/:recoveryId",
        component: () => import("../views/auth/ForgotPassword.vue")
      }
    ]
  },
  {
    path: "/notFound",
    name: 'NotFound',
    component: () => import("../views/NotFound.vue")
  },
  {
    path: "*",
    redirect: "/notFound"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
